export const BattleBg = {

    availableBg: ['defaultBG', 'vampireBG', 'seaAdvBG', 'islandAdvBG'],

    bgMapping: {
        28: 'vampireBG',
        29: 'vampireBG',
        30: 'vampireBG',
        43: 'vampireBG',
        31: 'seaAdvBG',
        32: 'seaAdvBG',
        33: 'seaAdvBG',
        44: 'seaAdvBG',
        45: 'islandAdvBG',
        46: 'islandAdvBG',
        47: 'islandAdvBG',
        48: 'islandAdvBG',
    },

    choiceBg: function (botId,) {

        let bg = 'defaultBG';
        if (botId !== null) {
            if (botId in BattleBg.bgMapping) {
                bg = BattleBg.bgMapping[botId];
            }
        } else { // pvp game
            bg = BattleBg.availableBg[Math.floor(Math.random() * BattleBg.availableBg.length)];
        }

        return bg;
    }
}